import * as React from 'react';
import { useTheme } from '@mui/material/styles';

import {
  Box,
  IconButton
} from '@mui/material';

import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

import style from "../../global.scss";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' 
        ? <LastPageIcon sx={{ color: page === 0 ? style["sub_text"] :style["primary_dark"]}}/> 
        : <FirstPageIcon sx={{ color: page === 0 ? style["sub_text"] :style["primary_dark"]}}/> }
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' 
        ? <KeyboardArrowRight sx={{ color: page === 0 ? style["sub_text"] :style["primary_dark"]}}/>  
        : <KeyboardArrowLeft sx={{ color: page === 0 ? style["sub_text"] :style["primary_dark"]}}/>}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' 
        ? <KeyboardArrowLeft sx={{ color: page >= Math.ceil(count / rowsPerPage) - 1 ? style["sub_text"] :style["primary_dark"]}}/> 
        : <KeyboardArrowRight sx={{ color: page >= Math.ceil(count / rowsPerPage) - 1 ? style["sub_text"] :style["primary_dark"]}}/> }
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' 
        ? <FirstPageIcon sx={{ color: page >= Math.ceil(count / rowsPerPage) - 1 ? style["sub_text"] :style["primary_dark"]}}/> 
        : <LastPageIcon sx={{ color: page >= Math.ceil(count / rowsPerPage) - 1 ? style["sub_text"] :style["primary_dark"]}}/> }
      </IconButton>
    </Box>
  );
}

export default TablePaginationActions;
